import type { ComboboxOptionObjectInterface, ComboboxOptionType } from '@zillow/constellation-10';
import { Box, FormField, Label } from '@zillow/constellation-10';

import TourDurationDropdownSelect from '../../../../TourDurationDropdownSelect';
import type { TourDuration } from '@zg-rentals/ts-z-calendar-client';

type TourDurationBodyProps = {
  tourDuration?: TourDuration;
  onSelectTourDuration: (tourDuration: TourDuration) => void;
};

const TourDurationBody = ({ tourDuration, onSelectTourDuration }: TourDurationBodyProps) => {
  const handleOptionSelect = (comboBoxOption: ComboboxOptionType) => {
    const option = comboBoxOption as ComboboxOptionObjectInterface;
    const tourDurationValue = option.value as TourDuration;

    onSelectTourDuration(tourDurationValue);
  };

  return (
    <Box data-testid="TourDurationBody" css={{ display: 'flex', flexDirection: 'column', gap: 'loose' }}>
      <FormField
        label={<Label size="lg">Length of each tour</Label>}
        control={<TourDurationDropdownSelect tourDuration={tourDuration} handleOptionSelect={handleOptionSelect} />}
        required
      />
    </Box>
  );
};

export default TourDurationBody;
